module.exports = __webpack_public_path__ + "img/document.edb5c239.svg";